/**
 * @generated SignedSource<<4047bb6faf390f0b6ce5be54999c13cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_item$data = {
  readonly hasActiveHoldForBuyer?: boolean | null;
  readonly hasPrivateListing: boolean | null;
  readonly isAvailable: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly isSold: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_item">;
  readonly " $fragmentType": "PdpSharedDetailReference_item";
};
export type PdpSharedDetailReference_item$key = {
  readonly " $data"?: PdpSharedDetailReference_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReference_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "hasActiveHoldForBuyer",
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0973886d33fee08a78f9344221cd3bfc";

export default node;
